import React, { useState, useEffect } from 'react';
import { Container, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, CircularProgress, List, ListItem, ListItemText, Typography, Divider } from '@mui/material';
import { Add, Delete, PictureAsPdf } from '@mui/icons-material';
import ModuleHeader from '../../components/ModuleHeader';
import api from '../../axios';
import { errorMsg } from '../../utils/errorMsg';

export default function MaoAmiga() {
  const [beneficiarios, setBeneficiarios] = useState([]);
  const [gcs, setGcs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [dialogB, setDialogB] = useState(false);
  const [formB, setFormB] = useState({ nome: '', contato: '', gc_id: '', observacoes: '' });
  const [detalhe, setDetalhe] = useState(null);
  const [dialogA, setDialogA] = useState(false);
  const [formA, setFormA] = useState({ tipo: '', descricao: '', valor: '', responsavel: '' });

  const carregar = async () => {
    setLoading(true); setErro('');
    try {
      const [b, g] = await Promise.all([api.get('/mao-amiga/beneficiarios'), api.get('/grupos-crescimento/', { params: { status: 'ativo' } })]);
      setBeneficiarios(b.data); setGcs(Array.isArray(g.data) ? g.data : []);
    } catch (e) { setErro(errorMsg(e) || 'Erro'); }
    setLoading(false);
  };
  useEffect(() => { carregar(); }, []);

  const salvarB = async () => {
    try { await api.post('/mao-amiga/beneficiarios', { ...formB, gc_id: Number(formB.gc_id) }); setDialogB(false); carregar(); }
    catch (e) { setErro(errorMsg(e)); }
  };
  const excluirB = async (id) => { if (!window.confirm('Excluir beneficiário?')) return; try { await api.delete(`/mao-amiga/beneficiarios/${id}`); carregar(); } catch (e) { setErro(errorMsg(e)); } };
  const abrirDetalhe = async (id) => { try { const r = await api.get(`/mao-amiga/beneficiarios/${id}`); setDetalhe(r.data); setDialogA(false); } catch (e) { setErro(errorMsg(e)); } };
  const salvarA = async () => {
    if (!detalhe) return;
    try { await api.post(`/mao-amiga/beneficiarios/${detalhe.id}/ajudas`, { ...formA, valor: formA.valor ? Number(formA.valor) : null }); setDialogA(false); abrirDetalhe(detalhe.id); carregar(); }
    catch (e) { setErro(errorMsg(e)); }
  };
  const pdf = async (id) => {
    try { const r = await api.get(`/mao-amiga/beneficiarios/${id}/relatorio/pdf`, { responseType: 'blob' }); const url = URL.createObjectURL(new Blob([r.data])); const a = document.createElement('a'); a.href = url; a.download = `beneficiario-${id}.pdf`; a.click(); URL.revokeObjectURL(url); }
    catch (e) { setErro(errorMsg(e)); }
  };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <ModuleHeader module="Grupos de Crescimento" title="Projeto Mão Amiga" />
      {erro && <Box sx={{ color: 'error.main', mb: 2 }}>{erro}</Box>}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant="contained" startIcon={<Add />} onClick={() => setDialogB(true)}>Novo beneficiário</Button>
      </Box>
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead><TableRow>{['Nome', 'Contato', 'GC', 'Status', 'Ações'].map(h => <TableCell key={h} sx={{ fontWeight: 700 }}>{h}</TableCell>)}</TableRow></TableHead>
            <TableBody>
              {beneficiarios.map(b => (
                <TableRow key={b.id} hover>
                  <TableCell><strong>{b.nome}</strong></TableCell>
                  <TableCell>{b.contato || '-'}</TableCell>
                  <TableCell>{b.gc_nome || '-'}</TableCell>
                  <TableCell><Chip size="small" color={b.status === 'ativo' ? 'success' : 'default'} label={b.status} /></TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => abrirDetalhe(b.id)}>Ajudas</Button>
                    <Button size="small" onClick={() => pdf(b.id)}><PictureAsPdf fontSize="small" /></Button>
                    <Button size="small" color="error" onClick={() => excluirB(b.id)}><Delete fontSize="small" /></Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog open={dialogB} onClose={() => setDialogB(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Novo beneficiário</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Nome" value={formB.nome} onChange={e => setFormB(f => ({ ...f, nome: e.target.value }))} sx={{ mt: 1, mb: 2 }} />
          <TextField fullWidth label="Contato" value={formB.contato} onChange={e => setFormB(f => ({ ...f, contato: e.target.value }))} sx={{ mb: 2 }} />
          <TextField fullWidth select label="GC" value={formB.gc_id} onChange={e => setFormB(f => ({ ...f, gc_id: e.target.value }))} sx={{ mb: 2 }}>
            {gcs.map(g => <MenuItem key={g.id} value={g.id}>{g.nome}</MenuItem>)}
          </TextField>
          <TextField fullWidth label="Observações" value={formB.observacoes} onChange={e => setFormB(f => ({ ...f, observacoes: e.target.value }))} />
        </DialogContent>
        <DialogActions><Button onClick={() => setDialogB(false)}>Cancelar</Button><Button variant="contained" onClick={salvarB}>Salvar</Button></DialogActions>
      </Dialog>

      <Dialog open={!!detalhe} onClose={() => setDetalhe(null)} maxWidth="sm" fullWidth>
        {detalhe && (
          <>
            <DialogTitle>{detalhe.nome}</DialogTitle>
            <DialogContent>
              <Typography variant="body2" color="text.secondary">{detalhe.gc_nome || ''} — {detalhe.contato || ''}</Typography>
              <Divider sx={{ my: 1 }} />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <Button size="small" startIcon={<Add />} onClick={() => setDialogA(true)}>Adicionar ajuda</Button>
              </Box>
              <List dense>
                {detalhe.ajudas.map(a => (
                  <ListItem key={a.id} secondaryAction={<Button size="small" color="error" onClick={() => api.delete(`/mao-amiga/ajudas/${a.id}`).then(() => abrirDetalhe(detalhe.id))}><Delete fontSize="small" /></Button>}>
                    <ListItemText primary={a.tipo} secondary={`${a.descricao || ''} — R$ ${a.valor || 0} — ${a.responsavel || ''}`} />
                  </ListItem>
                ))}
              </List>
            </DialogContent>
            <DialogActions><Button onClick={() => setDetalhe(null)}>Fechar</Button></DialogActions>
          </>
        )}
      </Dialog>

      <Dialog open={dialogA} onClose={() => setDialogA(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Adicionar ajuda</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Tipo (cesta, remédio...)" value={formA.tipo} onChange={e => setFormA(f => ({ ...f, tipo: e.target.value }))} sx={{ mt: 1, mb: 2 }} />
          <TextField fullWidth label="Descrição" value={formA.descricao} onChange={e => setFormA(f => ({ ...f, descricao: e.target.value }))} sx={{ mb: 2 }} />
          <TextField fullWidth label="Valor" value={formA.valor} onChange={e => setFormA(f => ({ ...f, valor: e.target.value }))} sx={{ mb: 2 }} />
          <TextField fullWidth label="Responsável" value={formA.responsavel} onChange={e => setFormA(f => ({ ...f, responsavel: e.target.value }))} />
        </DialogContent>
        <DialogActions><Button onClick={() => setDialogA(false)}>Cancelar</Button><Button variant="contained" onClick={salvarA}>Salvar</Button></DialogActions>
      </Dialog>
    </Container>
  );
}
